<template>
  <div class="home">
    <div class="banner py-4 mb-3 w-100">
      <div class="container d-flex justify-content-between align-items-center flex-wrap">
        <div><img src="@/assets/image/ai/ai_classroom_text.png" alt="" class=" object-contain"></div>
        <div class="row flex-nowrap">
          <div class="col-8 col-md bg-white square text-purple-class m-2 p-3 d-flex flex-column align-content-center">
            <p class="text-xl points mb-1 pb-2 whitespace-nowrap text-center px-md-5">{{ $t('AI.Home.myPoints') }}</p>
            <p class="mb-0 p-3"><span class="text-3xl font-semibold">{{ remainPoints }}</span> <span class="text-xl">{{ $t('AI.Home.pointUnit') }}</span></p>
          </div>
          <router-link :to="{ 'name': 'ai_records' }" class="col-4 col-md bg-white square d-flex align-items-center px-3 text-xl m-2 whitespace-pre-wrap">
            <p class="text-dark mb-0">{{ $t('AI.Home.viewUsageRecords') }}</p><img src="@/assets/image/ai/Arrow_right.png" alt="" class="object-contain">
          </router-link>
        </div>
      </div>
    </div>
    <div class="container" v-if="menuData">
      <div class="row">
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <img src="@/assets/image/ai/ai_gept.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
              <img src="@/assets/image/ai/ai_geptM.png" alt="" class="w-100 h-auto object-contain d-md-none">
            </a>
            <div class="p-2">
              <router-link @click.native="isShowMenu = false" :to="{ 'path': '/GEPT/overview?level=初級' }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_test.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.geptBeginner') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link :to="{ 'path': '/GEPT/overview?level=中級' }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_test.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.geptIntermediate') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
            <!-- <a class="d-block p-2 pointer"><img src="@/assets/image/ai/ai_button_03.png" alt="" class="w-100 h-auto object-contain"></a>
            <a class="d-block p-2 pointer"><img src="@/assets/image/ai/ai_button_04.png" alt="" class="w-100 h-auto object-contain"></a> -->
          </div>
        </div>
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <img src="@/assets/image/ai/ai_writing.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
              <img src="@/assets/image/ai/ai_writingM.png" alt="" class="w-100 h-auto object-contain d-md-none">
            </a>
            <div class="p-2">
              <router-link @click.native="isShowMenu = false" :to="{ 'path': '/quiz/overview?level=歷屆考古題' }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_clock.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.pastExamQuestions') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link :to="{ 'path': '/quiz/overview?level=模擬試題' }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_test.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.mockTest') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
          </div>
        </div>
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <img src="@/assets/image/ai/ai_letter.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
              <img src="@/assets/image/ai/ai_letterM.png" alt="" class="w-100 h-auto object-contain d-md-none">
            </a>
            <div class="p-2">
              <router-link :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'letter' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_letter.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.letterGenerator') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link  :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'letter' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_speech.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.aiCorrection') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
          </div>
        </div>
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <img src="@/assets/image/ai/ai_speech.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
              <img src="@/assets/image/ai/ai_speechM.png" alt="" class="w-100 h-auto object-contain d-md-none">
            </a>
            <div class="p-2">
              <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'speech' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_letter.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.speechScriptGenerator') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'speech' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_speech.png" alt="" class="object-contain d-inline">
                  {{ $t('AI.Home.aiCorrection') }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link :to="{ 'name': 'ai_assistant_follow', 'params': { aiType: 'speech' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <p class="m-0 d-flex align-items-center">
                  <img src="@/assets/image/ai/icon_chat.png" alt="" class="object-contain d-inline mr-1">
                  <span>
                    {{ $t('AI.Home.shadowingPractice') }}
                    <span class="d-block text-xs text-black-50 text-left">{{ $t('AI.Home.noAiPointsDeducted') }}</span>
                  </span>
                </p>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
          </div>
        </div>
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <img src="@/assets/image/ai/ai_speaking.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
              <img src="@/assets/image/ai/ai_speakingM.png" alt="" class="w-100 h-auto object-contain d-md-none">
            </a>
            <div class="p-2">
              <router-link :to="{ 'name': 'chatAI', 'params': { promptId: value } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold"
                v-for="(value, key, index) in menuData" :key="index">
                <span>
                  <img src="@/assets/image/ai/icon_apple.png" alt="" class="object-contain d-inline">
                  {{ key }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
          </div>
        </div>
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <img src="@/assets/image/ai/ai_speaking_jp.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
              <img src="@/assets/image/ai/ai_speaking_jpM.png" alt="" class="w-100 h-auto object-contain d-md-none">
            </a>
            <div class="p-2">
              <router-link :to="{ 'name': 'ChatAIJp', 'params': { promptId: value } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold"
                v-for="(value, key, index) in menuData2" :key="index">
                <span>
                  <img src="@/assets/image/ai/icon_apple.png" alt="" class="object-contain d-inline">
                  {{ key }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import api from '@/store/api'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Home',
    data () {
      return {
        selectedIdx: 1,
        menuData: null,
        menuData2: null,
        isShowMenu: true
      }
    },
    computed: {
      ...mapGetters(['remainPoints']),
      recentRoute () {
        const { name, params } = this.$route

        if (name === 'ai_assistantIntro') return this.$t('AI.Home.guide')

        if (name === 'ai_assistantMain') {
          return params.aiType === 'letter' ? this.$t('AI.Home.generateLetter') :
                params.aiType === 'speech' ? this.$t('AI.Home.generateSpeech') : this.$t('AI.Home.guide')
        }

        if (name === 'ai_assistant_correction') {
          return params.aiType === 'letter' ? this.$t('AI.Home.aiCorrection') :
                params.aiType === 'speech' ? this.$t('AI.Home.aiCorrection') : this.$t('AI.Home.guide')
        }

        if (name === 'chatAI' && this.menuData) {
          if (params.promptId === this.menuData['商業英語會話']) return this.$t('AI.Home.businessScenario')
          if (params.promptId === this.menuData['生活英語會話']) return this.$t('AI.Home.lifeScenario')
        }

        if (name === 'ai_assistant_follow') {
          return this.$t('AI.Home.shadowingPractice')
        }

        return this.$t('AI.Home.guide')
      }
    },
    mounted () {
      this.$store.dispatch('getRemainPoints')
      this.getMenu()
      this.getMenu2()
    },
    methods: {
      getMenu () {
        let self = this

        let path = `/ai/categories/list`
        const options = { headers: { 'showLoading': true }}
        api.get(path, options)
        .then((res) => {
          self.menuData = res.data
        })
      },
      getMenu2 () {
        let self = this

        let path = `/ai/categories/list?lang=ja-JP`
        const options = { headers: { 'showLoading': true }}
        api.get(path, options)
        .then((res) => {
          self.menuData2 = res.data
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
.home {
  background-color: #FAF5EF;
  min-height: 100vh;
}
.banner {
  min-height: 200px;
	background-image:
		url('~@/assets/image/ai/bg.png');
	background-repeat: repeat;
	background-position: center;
}
.square {
  min-height: 140px;
  border-radius: 20px;
  // white-space: nowrap;
  .points {
    border-bottom: 1px solid rgba(115, 44, 178, 1);
  }
}

.text-purple-class {
  color: rgba(115, 44, 178, 1);
}
a {
  &:hover {
    text-decoration: none !important;
  }
}
.button_item {
  border: 1px solid rgba(94, 160, 221, 1);
  border-radius: 8px;
}
</style>
